
import Dashboard from "layouts/dashboard";
import Maintenance from "layouts/maintenance";
import Vendors from "layouts/vendor-directory";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SiteMap from "layouts/sitemaps";
import Local_Link from "layouts/local_link";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
// import Units from "layouts/units";
import Calendar from "layouts/Calendar";
import Library from "layouts/library";
import Reservations from "layouts/reservations";
import PetRegistry from "layouts/petregistry";
import Instructions from "layouts/instructions";
import Incidents from "layouts/incident";
import Resident_Directory from "layouts/resident_directory";
import searchRequests from "layouts/searchRequests";
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import Property from "layouts/manager/property";
import EventLog from "layouts/eventlog";
import Email from "layouts/email";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';

const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "unit",
  //   route: "/manager/dashboard",
  //   activePaths: ["/manager/dashboard"],
  //   icon: <SpaceDashboardIcon size="12px" />,
  //   component: <Property />,
  //   noCollapse: true,
  //   children: []
  // },
  {
    type: "collapse",
    name: "Property",
    key: "property",
    route: "/manager/properties",
    activePaths: ["/manager/properties", "/manager/concierge"],
    icon: <Shop size="12px" />,
    component: <Property />,
    noCollapse: true,
    children: [],
  },

  // {
  //   type: "collapse",
  //   name: "Manage",
  //   key: "manage",
  //   route: "/manager/manage",
  //   icon: <Shop size="12px" />,
  //   component: <SiteMap />,
  //   noCollapse: false,
  //   children: [
  //     {
  //       type: "item",
  //       name: "Units/Occupants",
  //       key: "units-occupants",
  //       route: "/manager/unit-occupants",
  //       icon: <Office size="12px" />,
  //       component: <Resident_Directory />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Calendar",
  //       key: "calendar",
  //       route: "/manager/calendar",
  //       icon: <CalendarMonthIcon fontSize="small" />,
  //       component: <Calendar />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Library",
  //       key: "library",
  //       route: "/manager/library",
  //       icon: <Document size="12px" />,
  //       component: <Library />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Reservations",
  //       key: "reservations",
  //       route: "/manager/reservations",
  //       icon: <Cube size="12px" />,
  //       component: <Reservations />,
  //       noCollapse: true,
  //     },
  //     {
  //       type: "item",
  //       name: "Pet Registry",
  //       key: "pet-registry",
  //       route: "/manager/pet-registry",
  //       icon: <Settings size="12px" />,
  //       component: <PetRegistry />,
  //       noCollapse: true,
  //     },
  //   ],
  // },

  //   {
  //     type: "collapse",
  //     name: "Front Desk",
  //     key: "front-desk",
  //     route: "/manager/front-desk",
  //     activePaths: ["/manager/front-desk"],
  //     icon: <Shop size="12px" />,
  //     component: <SiteMap />,
  //     noCollapse: true,
  //     children: [
  //       {
  //         type: "item",
  //         name: "Event Log",
  //         key: "event-log",
  //         route: "/manager/event-log",
  //         icon: <CustomerSupport size="12px" />,
  //         component: <EventLog />,
  //         noCollapse: true,
  //       },
  //       {
  //         type: "item",
  //         name: "Instructions",
  //         key: "instructions",
  //         route: "/manager/instructions",
  //         icon: <Settings size="12px" />,
  //         component: <PetRegistry />,
  //         noCollapse: true,
  //       },
  //       {
  //         type: "item",
  //         name: "Incidents",
  //         key: "incidents",
  //         route: "/manager/incidents",
  //         icon: <Settings size="12px" />,
  //         component: <PetRegistry />,
  //         noCollapse: true,
  //       },
  //   ],
  //   },
  
];

export default routes;
